import { Moment } from 'moment'
import { VILLAS_MAXIMUM_TRAVEL_PERIOD_RANGE } from 'constants/villas'

export const isAnyDayInMonthInDiscountPeriod = (discounts: App.VillasDiscount[], month: Moment, duration) => {
  const daysInMonth = month.daysInMonth()
  return Array.from({ length: daysInMonth }, (_, i) => i + 1)
    .some(day => isDateWithinAnyDiscountPeriod(discounts, month.clone().date(day), duration))
}

export const isDateWithinAnyDiscountPeriod = (discounts: App.VillasDiscount[], checkIn: Moment, duration: number) => {
  const checkOut = checkIn.clone().add(duration, 'days')
  const millisecondsPerDay = 1000 * 60 * 60 * 24
  const daysToArrival = Math.round((checkIn.toDate().getTime() - new Date().getTime()) / millisecondsPerDay)

  for (const discount of discounts) {
    const isWithinAnySchedule = discount.schedules.some(schedule => {
      const isWithinActivePeriod = new Date() >= new Date(schedule.activePeriod.from) && new Date() <= new Date(schedule.activePeriod.to)
      const isWithinTravelPeriod = checkIn.toDate() >= new Date(schedule.travelPeriod.from) && checkOut.toDate() <= new Date(schedule.travelPeriod.to)
      if (isWithinActivePeriod && isWithinTravelPeriod) {
        return true
      }
      return false
    })

    const isWithinArrivalPeriod =
    (discount.minDaysToArrival === undefined || discount.minDaysToArrival === null || daysToArrival >= discount.minDaysToArrival) &&
    (discount.maxDaysToArrival === undefined || discount.maxDaysToArrival === null || daysToArrival <= discount.maxDaysToArrival)

    const isWithinLengthOfStay =
      (discount.minLos === undefined || discount.minLos === null || duration >= discount.minLos) &&
      (discount.maxLos === undefined || discount.maxLos === null || duration <= discount.maxLos)

    const isExternal = discount.source === 'external' // Only external source discounts are applicable

    if (
      isWithinAnySchedule &&
      isWithinArrivalPeriod &&
      isWithinLengthOfStay &&
      isExternal
    ) {
      return true
    }
  }
  return false
}

// Discount travel periods can be further than our allowable booking window.
// We limit discount label to x months from today.
const isTravelPeriodWithinTimeFrame = (schedules: App.VillasSchedule[], months: number) => {
  const today = new Date()
  const todayPlusMonths = new Date(today.setMonth(today.getMonth() + months))

  for (const schedule of schedules) {
    if (new Date(schedule.travelPeriod.from) <= today && new Date(schedule.travelPeriod.to) >= todayPlusMonths) {
      return true
    }
  }
  return false
}

export const getBestVillasDiscounts = (discounts: App.VillasDiscount[], maxDiscounts: number) => {
  const topDiscounts = discounts
    .filter(discount => discount.discountType !== 'last_minute' && isTravelPeriodWithinTimeFrame(discount.schedules, VILLAS_MAXIMUM_TRAVEL_PERIOD_RANGE))
    .sort((a, b) => b.discountPercent - a.discountPercent)
    .slice(0, maxDiscounts)

  return topDiscounts
}
